<template>
	<BasePopover :id="$options.name" :status.sync="status" :target-id="targetId">
		<template #title>
			<div class="title">
				<span>{{ $t("Ajoutez votre logo") }}</span>
				<span class="float-right">{{ `${current_popover_showed}/${total_popovers_to_show}` }}</span>
			</div>
		</template>

		<template #default>
			<vue2Dropzone
				id="dropzone-popover"
				ref="myVueDropzonePopover"
				:include-styling="false"
				:options="dropzoneOptions"
				:use-custom-slot="true"
				@vdropzone-success="logoUploaded"
			>
				<div class="dropzone-custom-content">
					<p v-if="!newLogo" class="box-dashed">
						<span class="blue-color">{{ $t("Importez") }}</span> {{ $t("ou glissez votre logo (.JPG)") }}
					</p>
				</div>
			</vue2Dropzone>

			<b-link class="link grey-color" @click="next">
				{{ $t("Ne pas ajouter de logo") }}
			</b-link>
		</template>
	</BasePopover>
</template>

<script>
	import { query, getToken, getApiKey } from "@sinao/core-js";
	import vue2Dropzone from "vue2-dropzone";
	import "vue2-dropzone/dist/vue2Dropzone.min.css";
	import { mapState } from "vuex";
	import i18n from "@/i18n";

	export default {
		name: "PopoverLogo",
		components: {
			vue2Dropzone
		},
		props: {
			targetId: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				newLogo: false,
				dropzoneOptions: {
					url: "https://localhost",
					thumbnailWidth: "300px",
					thumbnailHeight: "125px"
				}
			};
		},
		computed: {
			...mapState({
				appId: state => state.app.id,
				apiUrl: state => state.app.apiUrl,
        total_popovers_to_show: state => state.onboarding.total_popovers_to_show,
        current_popover_showed: state => state.onboarding.current_popover_showed,
			}),
			status: {
				get() {
					return this.$store.state.onboarding.showPopoverLogo;
				},
				set(value) {
					this.$store.commit("showPopoverLogo", value);
				}
			},
			logoURL: {
				get() {
					return this.$store.state.home.logoURL;
				},
				set(value) {
					this.$store.commit("logoURL", value);
				}
			}
		},
		created() {
			const _token = getToken();
			const _api_key = getApiKey();
			var headers = {};

			if (_token) {
				headers = { Authorization: `Bearer ${_token}` };
			} else if (_api_key) {
				headers = { 'Api-Key': `${_api_key}` };
			}

			this.dropzoneOptions = {
				url: `${this.apiUrl}/apps/${this.appId}/settings`,
				headers: headers,
				paramName: "value",
				params: {
					key: "accounting.printablelogo"
				},
				maxFiles: 1,
				clickable: true,
				addRemoveLinks: true,
				acceptedFiles: ".jpg,.jpeg,.png",
				thumbnailWidth: 300,
				thumbnailHeight: 125,
				thumbnailMethod: "contain",
				dictMaxFilesExceeded: i18n.t("Un seul logo"),
				dictFallbackText: i18n.t("Votre navigateur ne permet pas d’utiliser la version moderne du gestionnaire de logo"),
				dictRemoveFile: i18n.t("Changer le logo"),
				dictCancelUpload: i18n.t("Annuler le téléchargement"),
				// Automaticaly remove the previous file to allow for only one file at a time
				init: function() {
					this.on("addedfile", function() {
						if (this.files[1] != null) {
							this.removeFile(this.files[0]);
						}
					});
				}
			};
		},
		methods: {
			next() {
				query({
					operationId: "app.settings.update",
					params: {
						appId: this.appId
					},
					data: {
						settings: {
							"installation.onboarding.showPopoverLogo": 1
						}
					}
				});

				this.status = false;
        this.$store.commit("setPopovers", { key: "showPopoverLogo", value: false });
        this.$nextTick(() => {
          this.$store.dispatch('setNextOpenedPopover');
          this.$store.dispatch('incrementCurrentPopoverShowed');
        });
			},
			logoUploaded(file, response) {
				if (response.settings["accounting.printablelogo"]) {
					this.newLogo = true;
					this.logoURL = `${response.settings["accounting.printablelogo"]}?ts=${Date.now()}`;
					this.next();
				}
			},
			async logoRemoved() {
				this.newLogo = false;
				this.logoURL = null;
				this.logoBinary = null;
				this.$refs?.myVueDropzonePopover?.removeAllFiles(true);

				try {
					await query({
						operationId: "app.settings.update",
						params: {
							appId: this.appId
						},
						data: {
							settings: {
								"accounting.printablelogo": ""
							}
						}
					});
				} catch (error) {
					console.error(error);
				}
			}
		}
	};
</script>

<style lang="scss">
	@import "../../scss/utilities.scss";
	@import "../../scss/colors.scss";

	.dropzone-custom-content {
		padding: 0;
		margin: 0;
		border: none;
		cursor: pointer;
	}

	.dz-image {
		text-align: center;
		margin-bottom: 8px;
	}

	.dropzone .dz-preview:hover .dz-image img {
		transform: unset;
		filter: none;
	}

	.dz-image img {
		max-width: 300px;
		max-height: 125px;
		width: auto !important;
		height: auto !important;
	}

	.dz-details,
	.dz-error-message,
	.dz-success-mark,
	.dz-error-mark {
		display: none;
	}

	.dz-remove {
		@extend .link;
		@extend .grey-color;
	}
</style>
